import TeamPost from "views/Slack/TeamPost/TeamPost";
import TeamList from "views/Slack/TeamList/TeamList";
import TeamListTask from "views/Slack/TeamListTask/TeamListTask";
import PollListDetail from "views/Teams/TeamPoll/PollListDetail/PollListDetail.js";
import NoPost from "views/Teams/NoPost/NoPost.js";

const ringCentralRoutes = [
  {
    path: "/ringCentral/teams/:teamId/post/:postId",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    component: TeamPost,
    layout: "",
  },
  {
    path: "/ringCentral/teams/:teamId/todo-list/:listId",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    component: TeamList,
    layout: "",
  },
  {
    path: "/ringCentral/teams/:teamId/poll/:pollId/detail",
    name: "",
    icon: "",
    component: PollListDetail,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/ringCentral/teams/:teamId/noPost/:type",
    name: "",
    icon: "",
    component: NoPost,
    hideFromAllSidebar: true,
    layout: "",
  },
  {
    path: "/ringCentral/teams/:teamId/todo-list/:listId/todo-list-item/:taskId",
    hideFromAllSidebar: true,
    name: "",
    icon: "",
    exact: "true",
    component: TeamListTask,
    layout: "",
  },
];

export default ringCentralRoutes;
